import React from 'react';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {useTranslation} from "react-i18next";

const SHOPS_WITH_HIDDEN_WEBAPPZ_BRANDING = new Set(['6167']);

const PoweredByWebappz = () => {
    const {t} = useTranslation();
    const routeShopID = useParams().shopID;
    const sessionShopID = useSelector(state => state.user.user?.shopid);
    const shopID = sessionShopID ?? routeShopID;

    if (SHOPS_WITH_HIDDEN_WEBAPPZ_BRANDING.has(String(shopID))) {
        return null;
    }

    return (
        <p className='text-center w-100 p-2'>
            {t('powered_by')}
            <a href='https://t.me/webappzconnectbot/start' className='channel-link'>
                <b> webappz</b>
            </a>
        </p>
    );
};

export default PoweredByWebappz;
